import React, { Component } from 'react';
import { translate } from 'react-i18next';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import request from 'superagent';
import { Badge, Icon, Switch } from 'antd';
import moment from 'moment';
import AlertDetailModalAnt from './AlertDetailModalAnt.js';
import Loading from '../../commons/Loading.js';

const levelType = {
    'FATAL': 'Fatal',
    'ERROR': 'Error'
};

function levelFormatter(cell, row, enumObject) {
    return (
        <div style={{textAlign: 'center'}}>
            {cell === 'FATAL' ? (<Badge status="error"/>) : ( <Badge status="warning"/>) }
        </div>
    );
    /*return enumObject[cell];*/
}

function detailFormatter(cell, row, enumObject) {
    return (
        <AlertDetailModalAnt cell={cell} row={row} from={'service'}/>
    )
}

function filterType(cell, row) {
    return cell;
}

class AlertAnt extends Component {
    state = {
        data: [],
        errorCount: 0,
        fatalCount: 0,
        loading: false,
        isHistory: false,
        intervalId: 0
    };

    createCustomToolBar = props => {
        return (
            <div>
                <div className='buttonFiled'>
                    <div className='alertCount alertCount-red'>
                        <Icon type="exclamation-circle" className='alertCountIcon'/>
                        <div className="alertCountContent">
                            <div className="countNumber">{this.state.fatalCount} Fatal</div>
                            {/*<div className="countLevel">Fatal</div>*/}
                        </div>
                    </div>
                    <div className='alertCount alertCount-yellow'>
                        <Icon type="exclamation-circle" className='alertCountIcon'/>
                        <div className="alertCountContent">
                            <div className="countNumber">{this.state.errorCount} Error</div>
                           {/* <div className="countLevel">Error</div>*/}
                        </div>
                    </div>
                </div>
                <div className='searchFiled'>
                    <div className='alertHistory' style={{display:'none'}}>
                        <Switch className='alertHistorySwitch' defaultChecked={this.state.isHistory} onChange={isHistory => this.onChangeHistory(isHistory)}/>
                        <div className="alertHistoryLabel">Alert History</div>
                    </div>
                    <div className='alertSearch'>
                        { props.components.searchPanel }
                    </div>
                </div>
            </div>
        );
    }

    fetch = (params) => {
        //console.log('params:', params);
        //console.log('isHistory', this.state.isHistory);
        //var history = false;
        //if (JSON.stringify(params) != "{}") {
        //    history = params.history;
        //} else {
        //    history = this.state.isHistory;
        //}
        this.setState({loading: true});
        request.get('/api/dashboard/service/alerts')
            .withCredentials()
            .end((error, response) => {
                if (!error && response) {
                    let data = response.body;
                    let dataF = [];
                    let dataE = [];
                    for (let i = 0; i < data.length; i++) {
                        data[i].level = data[i].level.toUpperCase();
                        data[i].createTime4Show = moment(data[i].createTime).format("YYYY-MM-DD HH:mm:ss");
                        if (data[i].level === 'FATAL') {
                            dataF.push(data[i]);
                        } else if (data[i].level === 'ERROR') {
                            dataE.push(data[i]);
                        }
                    }
                    dataF.sort(function (a, b) {
                        return b.count - a.count;
                    });
                    dataE.sort(function (a, b) {
                        return b.count - a.count;
                    });
                    data = dataF.concat(dataE);
                    this.setState({
                        loading: false,
                        data: data,
                        errorCount: dataE.length,
                        fatalCount: dataF.length
                    });
                } else {
                    this.setState({
                        loading: false
                    });
                }
            });
    }

    componentDidMount() {
        this.fetch();
        const intervalId = setInterval(this.fetch, 30*60*1000);
        this.setState({intervalId: intervalId});
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }
    onChangeHistory(checked) {
        this.setState({isHistory: checked});
        this.fetch({history:checked});
    }
    render() {
        const data = this.state.data;
        const options = {
            noDataText: this.state.loading ? <Loading /> : 'No alert found.',
            toolBar: this.createCustomToolBar,
            searchDelayTime: 500
        };
        return (
            <div className=''>
                <BootstrapTable data={ data } search={ true } options={ options } striped hover condensed>
                    <TableHeaderColumn dataField='level' dataFormat={ levelFormatter } formatExtraData={ levelType }
                                       filter={ {type: 'SelectFilter', options: levelType} } filterValue={ filterType }
                                       dataSort={ true } width="10%">Level</TableHeaderColumn>
                    <TableHeaderColumn dataField='service_name' filter={{type: 'TextFilter'}} dataSort={ true } width="20%">Service Type</TableHeaderColumn>
                    <TableHeaderColumn dataField='message' isKey dataSort={ true } dataFormat={ detailFormatter }>Description</TableHeaderColumn>
                    <TableHeaderColumn dataField='count' dataSort={ true } width="10%">Count</TableHeaderColumn>
                    <TableHeaderColumn dataField='createTime4Show' dataSort={ true } width="12%">Create Time</TableHeaderColumn>
                    <TableHeaderColumn dataField='tid' hidden>tenantId</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}

export default translate()(AlertAnt);


// WEBPACK FOOTER //
// ./src/modules/dashboard/AlertAnt.js